import styled, { css } from "styled-components";

import { stylesGlobalDefault } from "../../global/globalStyle";

interface IRightTemplate {
  disabled?: boolean;
}
export const Container = styled.div<IRightTemplate>`
  background: rgb(236, 240, 243);
  min-width: 300px;
  max-width: 300px;
  padding: 24px;
  height: calc(100vh - 110px);
  overflow-y: auto;
  flex-direction: column;

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.6;
      cursor: default;
      z-index: -1;
    `}
`;

export const ContainerInfos = styled.div`
  margin-left: 0px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  width: "100%";
  display: "flex";
  flex-direction: row;
  align-items: "center";
  left: "0";
  justify-content: "flex-start";
`;

export const Right = styled.div`
  width: "100%";
  display: "flex";
  align-items: "center";
  right: "1";
  justify-content: "flex-end";
`;

export const FirstTexts = styled.div`
  margin-top: 24px;
  width: 100%;
`;

export const DatesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 50px;
  margin: 0px;
  padding: 0px;
`;

export const DateItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 156px;
`;

export const Spacer = styled.div`
  width: 100%;
  border-bottom: 1px solid rgb(209, 219, 227);
  padding-bottom: 24px;
  margin-bottom: 26.5px;
`;

//attachment

export const AttachmentListContainer = styled.div`
  overflow-y: auto;
  max-height: 300px;
`;

export const AttachmentEmpty = styled.div`
  font-size: 14px;
  color: #7887a9;
  margin-top: 24px;
  font-family: "Inter Tight", Arial, Helvetica, sans-serif;
`;

export const AttachmentContainer = styled.div`
  display: flex;
  width: "100%";
  height: 28px;

  border-radius: 8px;
  align-items: center;
  padding: 10px;
  margin-top: 8px;
  border: 2px solid rgb(236, 240, 243);
  align-items: center;
  justify-content: space-between;

  .container_buttons {
    visibility: hidden;
  }

  border: 2px solid #1d9bf0;

  .container_buttons {
    visibility: visible;
  }
`;

export const AttachmentIconContainer = styled.div`
  display: flex;
  width: 28px;
  height: 28px;
  border-radius: 50%;

  border: 1.5px solid #7887a9;
  align-items: center;
  justify-content: center;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Title = styled.div`
  font-family: "Inter";
  font-weight: 600;
  font-size: 12px;
`;
export const Description = styled.div`
  font-family: "Inter";
  font-size: 12px;
  font-weight: 400;
  margin-top: 4px;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;

  button {
    display: flex;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    background: ${stylesGlobalDefault.blue};
    margin-left: 12px;
    border: 0;

    cursor: pointer;
  }
`;
